import React, { useState } from "react";
import { Row, Col, message, Popover } from "antd";

//components
import ProgressBar from "../../components/ProgressBar";
import Wrapper from "../../components/Wrapper";
import { useRecoilState } from "recoil";
import { userAtom } from "../../Recoil/Atoms/user";

import { ReactComponent as Bread } from "../../assets/bread.svg";
import { ReactComponent as Wheat } from "../../assets/wheat.svg";
import { ReactComponent as Rice } from "../../assets/rice.svg";
import { ReactComponent as Potato } from "../../assets/potato.svg";
import { ReactComponent as Oats } from "../../assets/wheat.svg";
import { ReactComponent as BreadSelected } from "../../assets/breadselected.svg";
import { ReactComponent as WheatSelected } from "../../assets/wheatselected.svg";
import { ReactComponent as RiceSelected } from "../../assets/riceselected.svg";
import { ReactComponent as PotatoSelected } from "../../assets/potatoselected.svg";
import { ReactComponent as OatsSelected } from "../../assets/wheatselected.svg";
import { ReactComponent as Roti } from "../../assets/roti-canai.svg";
import { ReactComponent as RotiSelected } from "../../assets/roti-canai-1.svg";
import { ReactComponent as Sprout } from "../../assets/sprouts.svg";
import { ReactComponent as SproutSelected } from "../../assets/sprouts-1.svg";
import { ReactComponent as OatsNew } from "../../assets/oats.svg";
import { ReactComponent as OatsNewSelected } from "../../assets/oats-1.svg";

import { ReactComponent as Right } from "../../assets/Icon awesome-check.svg";
import { ReactComponent as Wrong } from "../../assets/Icon metro-cross.svg";

let LIST_VEG = [
  {
    id: 1,
    Title: "Oats",
    icon: OatsNew,
    selectedIcon: OatsNewSelected,
    content: "",
  },
  {
    id: 2,
    Title: "Rice",
    icon: Rice,
    selectedIcon: RiceSelected,
    content: "Recommend Brown Rice",
  },
  {
    id: 3,
    Title: "Sweet Potato",
    icon: Potato,
    selectedIcon: PotatoSelected,
  },
  {
    id: 4,
    Title: "Bread",
    icon: Bread,
    selectedIcon: BreadSelected,
    content: "Recommend  Brown Bread",
  },
  {
    id: 5,
    Title: "Quinoa",
    icon: Wheat,
    selectedIcon: WheatSelected,
  },
  {
    id: 6,
    Title: "Sprouts",
    icon: Sprout,
    selectedIcon: SproutSelected,
  },
  {
    id: 7,
    Title: "Roti",
    icon: Roti,
    selectedIcon: RotiSelected,
  },
  {
    id: 8,
    Title: "Pulses",
    icon: Wheat,
    selectedIcon: WheatSelected,
  },
  {
    id: 9,
    Title: "Legumes",
    icon: Wheat,
    selectedIcon: WheatSelected,
  },
];

const SelectGender = (props) => {
  const [selected, setSelected] = useState([]);
  const [userData, setUserData] = useRecoilState(userAtom);
  const [update, setupdater] = useState(false);

  const selectedMethod = (item) => {
    if (selected.indexOf(item.Title) !== -1) {
      let tempSelected = selected;
      tempSelected.splice(tempSelected.indexOf(item.Title), 1);
      console.log("TempSelected", tempSelected);
      setSelected(tempSelected);
    } else {
      setSelected([...selected, item.Title]);
    }
    setupdater(!update);
  };
  const selectNonVeg = async () => {
    if (selected.length > 2) {
      await setUserData({ ...userData, veg: selected });

      props.history.push("/SGF");
    } else {
      message.error("Please select at least 3 option ");
    }
  };
  return (
    <Wrapper {...props}>
      <Row className={"select_row"} align={"top"} justify="start">
        <Col align="left" span={8} xs={24} md={8}>
          <div className="blockname">
            <div style={{ marginLeft: "10rem" }} className="blocknametext">
              Select
            </div>
            <div style={{ marginLeft: "8rem" }} className="blocknametext">
              Carbs
            </div>
          </div>
        </Col>
        <Col align="center" span={8} xs={24} md={8}>
          <Row
            style={{ marginTop: "3rem" }}
            gutter={10}
            align="middle"
            justify="center"
          >
            <Col>
              <Right className="icon-change" />
            </Col>
            <Col className="background--grey">
              <h4 className="heading">Include / Exclude</h4>
            </Col>
            <Col>
              <Wrong className="icon-change" />
            </Col>
          </Row>
          <Row align="middle" justify="center">
            <h5 className="sub_heading background--grey">
              PLEASE CLICK TO INCLUDE PRODUCTS YOU LIKE:
            </h5>
          </Row>

          <Row gutter={20} align="middle" justify="center">
            {LIST_VEG.map((item, key) => {
              return (
                <Popover
                  content={item.content}
                  title={item.Title}
                  trigger="hover"
                >
                  <Col
                    onClick={() => selectedMethod(item)}
                    key={key}
                    align="center"
                    className={
                      selected.includes(item.Title)
                        ? "block__selected"
                        : "block"
                    }
                    span={6}
                  >
                    <Row
                      flex={1}
                      style={{ width: "100%" }}
                      align="middle"
                      justify="end"
                    >
                      {selected.includes(item.Title) ? (
                        <Right height="1rem" />
                      ) : (
                        <Wrong height="1rem" />
                      )}
                    </Row>
                    {selected.includes(item.Title) ? (
                      <item.selectedIcon height="5rem" />
                    ) : (
                      <item.icon height="5rem" />
                    )}
                    <h4 className="block_header">{item.Title}</h4>
                  </Col>
                </Popover>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Row align="middle" justify="center">
        <div onClick={() => selectNonVeg()} className="rowlabel">
          Continue
        </div>
      </Row>

      <ProgressBar value={65} />
    </Wrapper>
  );
};

export default SelectGender;
